import React from 'react'
import CuriosityCabinet from '../../components/CuriosityCabinet/CuriosityCabinet'
import PhilosophySection from '../../components/PhilosophySection/PhilosophySection'


function About () {

    return (
        <main>
            <PhilosophySection/>

            <CuriosityCabinet/>
        </main>
    )
}

export default About
